/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  Modal,
  Tabs,
  Descriptions,
  Avatar,
  Badge,
  Typography,
  Tag,
  Card,
  Space,
  Upload,
  message,
  Button,
  Input,
  Form,
  DatePicker,
  Radio,
  Checkbox,
  Row,
  Col,
  Divider,
  notification,
} from 'antd';
import { checkToken } from 'api/utils';
import {
  UploadOutlined,
  UserOutlined,
  SaveOutlined,
  CheckOutlined,
  PlusOutlined,
  DeleteOutlined,
  EditOutlined,
} from '@ant-design/icons';
import Table from 'components/Table';
import { getEstadosGlobales } from 'api/catalogos';
import { getCandidato, getCandidatovistaOptimized } from 'api/catalogos/Candidatos';
import moment from 'moment';
import { patchEntrevista } from 'api/Entrevistas';
import {
  deleteEntrevistaFamiliar, getEntrevistasFamiliar, getEntrevistasFamiliarParentesco, patchEntrevistaFamiliar, postEntrevistaFamiliar,
} from 'api/EntrevistasFamiliar';
import Select from 'components/Select';
import { getEntrevistasSalud, patchEntrevistaSalud, postEntrevistaSalud } from 'api/EntrevistasSalud';
import {
  deleteEntrevistaTrayectoria, getEntrevistasTrayectoria, patchEntrevistaTrayectoria, postEntrevistaTrayectoria,
} from 'api/EntrevistasTrayectoria';
import { getEntrevistaCompetencias, getEntrevistasCompetencias, patchEntrevistaCompetencias } from 'api/EntrevistasCompetencias';
import {
  getEntrevistasTrayectoriaPreguntas, getEntrevistaTrayectoriaPreguntas, patchEntrevistaTrayectoriaPreguntas, postEntrevistaTrayectoriaPreguntas,
} from 'api/EntrevistasTrayectoriaPreguntas';
import {
  getEntrevistaNotas, getEntrevistasNotas, patchEntrevistaNotas, postEntrevistaNotas,
} from 'api/EntrevistasNotas';
import {
  getEntrevistasCaracteristicas, getEntrevistasCaracteristicasCaracteristicas, patchEntrevistaCaracteristicas, postEntrevistaCaracteristicas,
} from 'api/EntrevistasCaracteristicasObservables';
import { set } from 'lodash';
import CustomSearch from 'components/customSearch';
import { getEmpleado, getEmpleadosConDatosOpFilteredPaginated } from 'api/estructuraOrganizacional/empleados';
import { getPlaza } from 'api/catalogos/plazas';
import { getDatoOperacionalesDeEmpleados } from 'api/estructuraOrganizacional/datosOperacionalesDeEmpleados';
import { getEstadosCiviles, getGeneros } from 'api/usuarios';
import FormSubmitControls from 'components/FormSubmitControls';
import EditableTable from 'components/EditableTable';
import CurrencyInput from 'components/CurrencyInput';

const { TabPane } = Tabs;
const { Title, Text } = Typography;
const { TextArea } = Input;

export default function CandidatoInfoGeneral({
  entrevista,
}) {
  const [form] = Form.useForm();
  const [saludForm] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const [candidatoDetalle, setCandidatoDetalle] = useState(null);
  const [entrevistasFamiliar, setEntrevistasFamiliar] = useState([]);
  const [entrevistasFamiliarParentesco, setEntrevistasFamiliarParentesco] = useState([]);
  const [entrevistasSalud, setEntrevistasSalud] = useState([]);
  const [entrevistasTrayectoria, setEntrevistasTrayectoria] = useState([]);
  const [entrevistaCompetencias, setEntrevistaCompetencias] = useState(null);
  const [entrevistatrasectoriaPreguntas, setEntrevistaTrayectoriaPreguntas] = useState(null);
  const [estados, setEstados] = useState([]);
  const [preguntasForm] = Form.useForm();
  const [entrevistaPreguntas, setEntrevistaPreguntas] = useState(null);
  const [entrevistasNotas, setEntrevistasNotas] = useState([]);
  const [entrevistasCaracteristicas, setEntrevistasCaracteristicas] = useState([]);
  const [entrevistasCaracteristicasCaracteristicas, setEntrevistasCaracteristicasCaracteristicas] = useState([]);
  const [notasForm] = Form.useForm();

  const [selectedEntrevistador, setSelectedEntrevistador] = useState(null);

  // Estados para modales de agregar datos
  const [trayectoriaData, setTrayectoriaData] = useState([]);
  const [familiarData, setFamiliarData] = useState([]);
  const [generos, setGeneros] = useState([]);
  const [estadoCivil, setEstadoCivil] = useState([]);

  // Formularios para modales

  useEffect(() => {
    if (/* !isOpen  || */ !entrevista?.id || !entrevista?.candidato) {
      return () => { }; //  función vacía en lugar de "return;"
    }

    let mounted = true;

    const getValor = (c) => {
      if (c.presente === true) return true;
      if (c.no_presente === true) return false;
      return null;
    };

    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      try {
        const [
          _estados,
          _candidatoDetalle,
          _entrevistasFamiliar,
          _entrevistasFamiliarParentesco,
          _entrevistasSalud,
          _entrevistasTrayectoria,
          _entrevistaCompetencias,
          _entrevistasTrayectoriaPreguntas,
          _entrevistasNotas,
          _entrevistasCaracteristicas,
          _entrevistasCaracteristicasCaracteristicas,
          _generos,
          _estadosCivil,
        ] = await Promise.all([

          getEstadosGlobales(),
          getCandidato(entrevista.candidato),
          getEntrevistasFamiliar({ entrevista: entrevista.id }),
          getEntrevistasFamiliarParentesco({ entrevista: entrevista.id }),
          getEntrevistasSalud({ entrevista: entrevista.id }),
          getEntrevistasTrayectoria({ entrevista: entrevista.id }),
          getEntrevistasCompetencias({ entrevista: entrevista.id }),
          getEntrevistasTrayectoriaPreguntas({ entrevista: entrevista.id }),
          getEntrevistasNotas({ entrevista: entrevista.id }),
          getEntrevistasCaracteristicas({ entrevista: entrevista.id }),
          getEntrevistasCaracteristicasCaracteristicas(),
          getGeneros(),
          getEstadosCiviles(),
        ]);

        if (mounted) {
          setEstadoCivil(_estadosCivil);
          setGeneros(_generos);
          setEstados(_estados);
          setCandidatoDetalle(_candidatoDetalle);
          setEntrevistasCaracteristicasCaracteristicas(_entrevistasCaracteristicasCaracteristicas);

          // Tablas
          setEntrevistasFamiliar(_entrevistasFamiliar.results || []);
          setEntrevistasFamiliarParentesco(_entrevistasFamiliarParentesco || []);
          setEntrevistasSalud(_entrevistasSalud.results || []);
          setEntrevistasTrayectoria(_entrevistasTrayectoria.results || []);
          setEntrevistaCompetencias(_entrevistaCompetencias.results || []);
          setEntrevistasNotas(_entrevistasNotas.results || []);
          setEntrevistasCaracteristicas(
            (_entrevistasCaracteristicas.results || []).map((c) => {
              const catalogo = _entrevistasCaracteristicasCaracteristicas.find(
                (cat) => cat.id === c.caracteristica_observable,
              );
              return {
                ...c,
                key: c.id,
                valor: getValor(c),
                caracteristicaNombre: catalogo ? catalogo.nombre : `#${c.caracteristica_observable}`,
              };
            }),
          );

          // Preload forms
          if (_entrevistasNotas.results?.[0]) {
            const nota = _entrevistasNotas.results[0];
            notasForm.setFieldsValue(nota);

            //  cargar entrevistador si ya está guardado
            if (nota.empleado) {
              const empleadoId = nota.empleado;

              const _empleado = await getEmpleado(empleadoId);
              const [datoOperacional] = await getDatoOperacionalesDeEmpleados({ empleado: empleadoId });

              let plazaDetalle = null;
              if (datoOperacional?.plaza) {
                plazaDetalle = await getPlaza(datoOperacional.plaza);
              }

              const nombreCompleto = `${_empleado.numero_de_empleado} - ${_empleado.nombre} ${_empleado.apellido_paterno} ${_empleado.apellido_materno || ''}`;

              const valoresForm = {
                entrevistador: nombreCompleto,
                area_entrevistador: plazaDetalle?.directorio_de_area_nombre || '',
                puesto_entrevistador: plazaDetalle?.puesto_descripcion || '',
              };

              setSelectedEntrevistador({
                ..._empleado,
                area: valoresForm.area_entrevistador,
                puesto: valoresForm.puesto_entrevistador,
              });

              notasForm.setFieldsValue({
                ...nota, // mantiene observaciones
                ...valoresForm, // añade entrevistador, área y puesto
              });
            }
          }

          if (_entrevistasTrayectoriaPreguntas.results?.[0]) {
            preguntasForm.setFieldsValue(_entrevistasTrayectoriaPreguntas.results[0]);
          }
          if (_entrevistasSalud.results?.[0]) {
            saludForm.setFieldsValue(_entrevistasSalud.results[0]);
          }

          form.setFieldsValue({
            sueldo_solicitado: entrevista.sueldo_solicitado,
            disponibilidad_laboral: entrevista.disponibilidad_laboral,
          });

          // Tablas familiares y trayectorias
          setFamiliarData((_entrevistasFamiliar.results || []).map((f) => ({ key: f.id, ...f })));
          setTrayectoriaData(_entrevistasTrayectoria.results || []);

          setEntrevistaTrayectoriaPreguntas(_entrevistasTrayectoriaPreguntas.results || []);
          setEntrevistaPreguntas(_entrevistasTrayectoriaPreguntas.results?.[0] || null);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchAll();

    return () => {
      mounted = false;
    };
    // eslint-disable-next-line
  }, [/* isOpen, */ entrevista]);

  useEffect(() => {
    if (selectedEntrevistador) {
      form.setFieldsValue({
        entrevistador: `${selectedEntrevistador.numero_de_empleado} - ${selectedEntrevistador.nombre} ${selectedEntrevistador.apellido_paterno} ${selectedEntrevistador.apellido_materno || ''}`,
        area_entrevistador: selectedEntrevistador.area || '', // aquí usas el valor que seteaste tras getPlaza
        puesto_entrevistador: selectedEntrevistador.puesto || '',
      });
    }
  }, [selectedEntrevistador, form]);

  const calcularEdad = (fechaNacimiento) => {
    if (!fechaNacimiento) return null;
    const hoy = moment();
    const nacimiento = moment(fechaNacimiento);
    if (!nacimiento.isValid()) return null;
    return hoy.diff(nacimiento, 'years');
  };

  const normalizeCandidate = (c, generosList = [], estadosCivilList = []) => {
    if (!c) return null;

    const generoObj = generosList.find((g) => g.id === c.genero);
    const estadoCivilObj = estadosCivilList.find((e) => e.id === c.estado_civil);

    return {
      nombre: c.numero_y_nombre_completo,
      genero: generoObj?.descripcion || '—',
      estadoCivil: estadoCivilObj?.descripcion || '—',
      edad: calcularEdad(c.fecha_de_nacimiento),
      telefono: c.numero_de_telefono,
      celular: c.numero_de_celular,
      correo: c.correo_electronico,
      fechaNacimiento: c.fecha_de_nacimiento,
      fechaAplicacion: c.solicitud_de_contratacion?.fecha_de_solicitud || null,
      referente: c.referente || '—',
      domicilio: c.domicilio,

      // Información de la vacante
      vacanteArea: c.solicitud_de_contratacion?.directorio_de_area_adscripcion?.clave_y_nombre,
      vacantePuesto: c.solicitud_de_contratacion?.puesto?.clave_y_descripcion,
      vacantePlaza: c.solicitud_de_contratacion?.puesto_plaza?.clave_y_descripcion
        || c.solicitud_de_contratacion?.plaza?.descripcion,
      vacanteTipoEmpleado: c.solicitud_de_contratacion?.tipo_empleado?.descripcion,
      vacanteMotivo: c.solicitud_de_contratacion?.motivo_de_reclutamiento?.nombre,
      vacanteOficio: c.solicitud_de_contratacion?.no_de_oficio,

      // Área solicitante
      // Área solicitante
      solicitanteNombre: c.solicitud_de_contratacion?.empleado?.numero_y_nombre_completo,
      solicitanteArea: c.solicitud_de_contratacion?.directorio_de_area_adscripcion?.clave_y_nombre,
      solicitantePuesto: c.solicitud_de_contratacion?.puesto?.clave_y_descripcion,
      solicitantePlaza: c.solicitud_de_contratacion?.puesto_plaza?.clave_y_descripcion
        || c.solicitud_de_contratacion?.plaza?.descripcion,

      // Otros
      estatusCandidato: c.estado_del_candidato?.descripcion,
      escolaridad: c.solicitud_de_contratacion?.nivel_de_estudios?.nombre || c.nivel_de_estudios?.nombre,
      fuenteReclutamiento: c.fuente_de_reclutamiento?.descripcion ?? '—',
      institucion: c.especialidad_estudio,
      anioGraduacion: c.anioGraduacion,
      cvURL: c.comprobante?.nombre,
      pruebas: c.candidato_pruebas_y_otros,
    };
  };

  const normalized = normalizeCandidate(candidatoDetalle, generos, estadoCivil);

  if (!entrevista) return null;

  return (
    <div style={{ maxHeight: 'calc(100vh - 250px)', overflowY: 'auto', padding: '0 8px' }}>
      <Space align="start" className="mb-5" size="large">
        <Avatar size={72} icon={<UserOutlined />} />
        <div>
          <Title level={4} style={{ marginBottom: 0 }}>{entrevista.nombre}</Title>
          <Text type="secondary">{entrevista.email}</Text>
          <div className="mt-2">
            <Badge status="processing" text={entrevista.vacantePlaza} style={{ marginRight: 8 }} />
            <Badge status="default" text={entrevista.estatus} />
          </div>
        </div>
      </Space>

      {/* Información Personal */}
      <Card title="Información Personal" bordered className="mb-4" size="small">
        <Descriptions
          column={{
            xs: 1, sm: 2, md: 2, lg: 2,
          }}
          size="small"
          bordered
        >
          <Descriptions.Item label="Nombre">{normalized?.nombre || '—'}</Descriptions.Item>
          <Descriptions.Item label="Género">{normalized?.genero || '—'}</Descriptions.Item>
          <Descriptions.Item label="Edad">{normalized?.edad ?? '—'}</Descriptions.Item>
          <Descriptions.Item label="Estado Civil">{normalized?.estadoCivil || '—'}</Descriptions.Item>
          <Descriptions.Item label="Escolaridad">{normalized?.escolaridad || '—'}</Descriptions.Item>
          <Descriptions.Item label="Teléfono Celular">{normalized?.celular || '—'}</Descriptions.Item>
          <Descriptions.Item label="Fuente de Reclutamiento">{normalized?.fuenteReclutamiento || '—'}</Descriptions.Item>
          <Descriptions.Item label="Referente">{normalized?.referente || '—'}</Descriptions.Item>
        </Descriptions>
      </Card>
      {/* Información de Vacante */}
      <Card title="Información de la Vacante" bordered className="mb-4" size="small">
        <Descriptions
          column={{
            xs: 1, sm: 2, md: 2, lg: 2,
          }}
          size="small"
          bordered
        >
          <Descriptions.Item label="Área">{normalized?.vacanteArea ?? '—'}</Descriptions.Item>
          <Descriptions.Item label="Puesto">{normalized?.vacantePuesto ?? '—'}</Descriptions.Item>
          <Descriptions.Item label="Plaza">{normalized?.vacantePlaza ?? '—'}</Descriptions.Item>
          <Descriptions.Item label="Tipo de Empleado">{normalized?.vacanteTipoEmpleado ?? '—'}</Descriptions.Item>
          <Descriptions.Item label="Motivo de Reclutamiento">{normalized?.vacanteMotivo ?? '—'}</Descriptions.Item>
          <Descriptions.Item label="Oficio">{normalized?.vacanteOficio ?? '—'}</Descriptions.Item>
          <Descriptions.Item label="Pruebas Asignadas">
            {normalized?.pruebas
              ? [...new Set(normalized.pruebas.split(','))].map((p) => (
                <Tag key={p.trim()}>{p.trim()}</Tag>
              ))
              : '—'}
          </Descriptions.Item>
        </Descriptions>
      </Card>

      {/* Información del Área */}
      <Card title="Información del Solicitante" bordered className="mb-4" size="small">
        <Descriptions
          column={{
            xs: 1, sm: 2, md: 2, lg: 2,
          }}
          size="small"
          bordered
        >
          <Descriptions.Item label="Nombre del Solicitante">{normalized?.solicitanteNombre ?? '—'}</Descriptions.Item>
          <Descriptions.Item label="Área">{normalized?.solicitanteArea ?? '—'}</Descriptions.Item>
          <Descriptions.Item label="Puesto">{normalized?.solicitantePuesto ?? '—'}</Descriptions.Item>
          <Descriptions.Item label="Plaza">{normalized?.solicitantePlaza ?? '—'}</Descriptions.Item>
        </Descriptions>
      </Card>

    </div>

  );
}
